import { useRef } from "react";
import { ActionHandlerProvider } from "../../../Components/ActionHandlerContext";
import DynamicMaster from "../../../Components/DynamicMaster/DynamicMaster";
import { InsertUpdateUserMaster } from "../../../Helpers/APIEndpoints/Endpoints";
import {
  GetRolesSystemName,
  getUserRoles,
} from "../../../Helpers/APIEndpoints/Endpoints";
import { API } from "../../../Axios/Axios";
import { useNavigate } from "react-router-dom";
import { FormInstance, message } from "antd";
import { RoleEnum } from "../../../Enum/RoleEnum";
import { useAuthStore } from "../../../AuthStore/AuthStore";

/* ⭐ CUSTOM REF TYPE */
// interface DynamicMasterRef {
//   hideFields: (fields: string[]) => Promise<void>;
//   showFields: (fields: string[]) => Promise<void>;
//   setValue: (field: string, value: any) => Promise<void>;
//   reloadDashboard?: () => Promise<void>;
// }

export default function UserMaster() {
  /* ⭐ DECLARE REF FIRST */
  const formRef = useRef<FormInstance>(null);
  const navigate = useNavigate();
  const { commonContextParams } = useAuthStore();

  const hideFields = (fieldNames: string[]) => {
    fieldNames.forEach((name, i) => {
      setTimeout(() => formRef.current?.hideFields(name), i * 0);
    });
  };

  const showFields = (fieldNames: string[]) => {
    fieldNames.forEach((name, i) => {
      setTimeout(() => formRef.current?.showFields(name), i * 0);
    });
  };

  const interfaceFieldActionHandler = {
    handleRoleChange: async (form: any) => {
      if (form && typeof form.getFieldsValue === "function") {
        const values = form.getFieldsValue();

        const roleId = values?.UserRole?.value ?? values?.UserRole;

       
        if (Number(roleId) === RoleEnum.Admin) {
          formRef.current?.setFieldVisibility([
            {
              fieldName: "Department",
              updates: { isFieldVisible: false },
            },
            {
              fieldName: "BusinessUnit",
              updates: { isFieldVisible: false },
            },
          ]);
          //hideFields(["Department", "BusinessUnit"]);

          // Optional: Clear values
          // await formRef.current?.setValue("Department", null);
          // await formRef.current?.setValue("BusinessUnit", null);
        } else {
          //showFields(["Department", "BusinessUnit"]);
          formRef.current?.setFieldVisibility([
            {
              fieldName: "Department",
              updates: { isFieldVisible: true },
            },
            {
              fieldName: "BusinessUnit",
              updates: { isFieldVisible: true },
            },
          ]);
        }

        console.log(values);
      }
    },
  };

  debugger;
  const interfaceActionHandler = {
    InsertUpdateUsermaster: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);

      const formData = params[0];
      console.log(formData);

      const param = {
        RId: formData.RId ?? 0,
        // Id: formData.RId ?? 0,

        UserId: Number(commonContextParams?.userId), // REQUIRED
        roleId: Number(commonContextParams?.roleId),
        //Number(formData.roleId ?? null), // REQUIRED
        UserRole: Number(formData.UserRole ?? null), // REQUIRED
        User: formData.User ?? null,
        Department: Array.isArray(formData.Department)
          ? formData.Department.join(",")
          : (formData.Department ?? null),

        BusinessUnit: Array.isArray(formData.BusinessUnit)
          ? formData.BusinessUnit.join(",")
          : (formData.BusinessUnit ?? null),

        IsActive:
          formData.IsActive === true || formData.IsActive === "true"
            ? true
            : false,
        CreatedBy: formData.CreatedBy ?? null, // REQUIRED
      };

      console.log("Param to post", param);

      let updateResponse = await API.post(InsertUpdateUserMaster, param);
      return updateResponse;
      // if (updateResponse.data.status !== 0) {
      //   message.error(
      //     updateResponse.data?.errorCode === "DBVALIDATION"
      //       ? updateResponse.data.message
      //       : "Failed.",
      //   );
      //   return null;
      // }

      //   // On success
      //  // debugger;
      //   message.success("Saved successfully!");
      //   //navigate("/UserDashboard");
      //   return updateResponse;

      // updateResponse.data.success = true;
      // updateResponse.data.message = "ok";

      // return {
      //   success: true,
      //   data: updateResponse.data,
      //   message: "ok",
      // };
    },
  };

  return (
    <ActionHandlerProvider
      interfaceFieldActionHandler={interfaceFieldActionHandler}
      interfaceActionHandler={interfaceActionHandler}
    >
      <DynamicMaster
        InterfaceName={"User Master"}
        DashboardName={"User Dashboard"}
        ref={formRef}
      />
    </ActionHandlerProvider>
  );
}
